<table mat-table [dataSource]="docentes" class="mat-elevation-z8">
  <ng-container matColumnDef="nome">
    <th mat-header-cell *matHeaderCellDef i18n="@@nome">Nome</th>
    <td mat-cell *matCellDef="let docente" data-label="Nome" i18n-data-label="@@nome" class="sem-label">
      <div class="docente-cell">
        <img [src]="docente.fotoLattesUrl || ''" alt="" class="foto-docente">
        <div class="docente-info">{{ docente.nome }}</div>
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="linhas">
    <th mat-header-cell *matHeaderCellDef i18n="@@linhas_pesquisa">Linhas de pesquisa</th>
    <td mat-cell *matCellDef="let docente" data-label="Linhas de pesquisa" i18n-data-label="@@linhas_pesquisa" class="sem-label">{{ docente.linhas }}</td>
  </ng-container>
  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef i18n="@@portalDocentes" style="text-align: right;">Portal Docentes</th>
    <td mat-cell *matCellDef="let docente" style="text-align: right;">
      @if (docente.docenteUnesp) {
        <button mat-icon-button (click)="portalDocentes(docente)">
          <mat-icon>open_in_new</mat-icon>
        </button>
      }
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="docenteColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: docenteColumns;"></tr>
</table>